import touchRippleClasses from "@mui/material/ButtonBase/touchRippleClasses";
import paginationItemClasses from "@mui/material/PaginationItem/paginationItemClasses";
import paginationClasses from "@mui/material/Pagination/paginationClasses";
import { typographyResponsive } from "../../styles/utils/typography.module";
export const MuiPaginationItemTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: Object.assign(Object.assign({}, typographyResponsive(dt, "body2.medium", {})), { margin: 0, borderRadius: dt.borderRadius.pill, minWidth: dt.size.xLarge4, height: dt.size.xLarge4, lineHeight: dt.size.xLarge4, paddingRight: dt.space.inline.xSmall, paddingLeft: dt.space.inline.xSmall, color: dt.color.onSurface.variant, ".PixelIcon": {
                    width: dt.icon.size.small,
                    height: dt.icon.size.small,
                    '&:not([class*="MuiSvgIcon-color"])': {
                        backgroundColor: dt.color.onSurface.variant,
                    },
                }, [`.${touchRippleClasses.ripple}`]: {
                    display: "none",
                }, [`li:first-of-type > &.${paginationItemClasses.firstLast}`]: {
                    marginRight: `-${dt.inline.xSmall}`,
                }, [`li:last-of-type > &.${paginationItemClasses.firstLast}`]: {
                    marginLeft: `-${dt.inline.xSmall}`,
                }, [`&.${paginationItemClasses.disabled}`]: {
                    opacity: dt.opacity.states.disabled.content,
                }, [`.${paginationClasses.root}:is(.Pxl-demo-hover, [data-demostate=hover]) &:where(button),
            &:where(button):hover`]: {
                    background: dt.cta.outlined.color.background.neutral.hover,
                }, [`.${paginationClasses.root}:is(.Pxl-demo-pressed, [data-demostate=pressed]) &:where(button),
          &:where(button):active`]: {
                    background: dt.cta.outlined.color.background.neutral.pressed,
                }, [`.${paginationClasses.root}.Pxl-demo-focused &:where(button),
          &:where(button):focus-visible`]: {
                    position: "relative",
                    zIndex: 1,
                    color: dt.color.onPrimary.container,
                    background: dt.cta.outlined.color.background.neutral.focus,
                    boxShadow: dt.state.focus.neutral,
                    [`&.${paginationItemClasses.textPrimary}, &.${paginationItemClasses.outlinedPrimary}`]: {
                        color: dt.color.onPrimary.container,
                        background: dt.color.primary.container,
                        boxShadow: dt.state.focus.primary,
                    },
                    [`&.${paginationItemClasses.textSecondary}, &.${paginationItemClasses.outlinedSecondary}`]: {
                        color: dt.color.onSecondary.container,
                        background: dt.color.secondary.container,
                        boxShadow: dt.state.focus.secondary,
                    },
                }, [`.${paginationClasses.root}:is(.Pxl-demo-active, [data-demostate=active]) &:where(button),
            &:where(button).Mui-selected`]: {
                    color: dt.color.onPrimary.container,
                    background: dt.color.surface.variant,
                    [`&.${paginationItemClasses.textPrimary}, &.${paginationItemClasses.outlinedPrimary}`]: {
                        color: dt.color.onPrimary.container,
                        background: dt.color.primary.container,
                    },
                    [`&.${paginationItemClasses.textSecondary}, &.${paginationItemClasses.outlinedSecondary}`]: {
                        color: dt.color.onSecondary.container,
                        background: dt.color.secondary.container,
                    },
                } }),
        },
    };
};
